// extracted by mini-css-extract-plugin
export default {"fab":"SendUserRequestFormFab_fab__u4IS7","fabButton":"SendUserRequestFormFab_fabButton__lUT+w"};